import { useFeatureLoyaltyRewardListCategoriesQuery } from 'generated/sanity-graphql';

export const FEATURE_LOYALTY_REWARD_LIST_CATEGORIES_SINGLETON_ID = 'reward-list-singleton';
export const useFeatureLoyaltyRewardListCategories = () => {
  const { data, loading } = useFeatureLoyaltyRewardListCategoriesQuery({
    variables: {
      featureLoyaltyRewardListCategoriesId: FEATURE_LOYALTY_REWARD_LIST_CATEGORIES_SINGLETON_ID,
    },
  });

  return {
    data: data?.RewardList?.rewardCategories,
    loading,
  };
};
